import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
    AssignmentContainer,
    ImportantAssignmentContainer,
    AssignmentCompleteContainer,
    AssignmentUpcomingContainer,
    StatContainer,
    IconContainer,
    InfoPane
} from "../styled_components/containers";
import star from "../assets/star.png";
import calendar from "../assets/calendar.png";
import PlayButton from "../styled_components/play_button";
import game_data from "../../games/game_data";

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

function AssignmentName(assignment){
    var myname = "";
    let subject = game_data.find(gd => gd.id == assignment.galaxy_id);

    if (assignment.important == 1){
        myname+= "Important "
    }

    console.log(assignment);

    if (assignment.galaxy_id == 35){
        var assessment_type = assignment.assessment_type.split("_");
        var mtcfixeddtype = assignment.assessment_type.split("|");
        
        //special ones
        if (assignment.assessment_type == "numberbonds1020"){
            myname += "Number Bonds 10 & 20 assessment";
        }
        else if (assignment.assessment_type == "mtcnetlimited" || assignment.assessment_type == "mtcnetlimited|access"){
            myname+= "MTC Type assessment - 2, 3, 5 & 10 Times Tables"
        }
        else if (assignment.assessment_type == "mtcnetlimited3" || assignment.assessment_type == "mtcnetlimited3|access"){
            myname+= "MTC Type assessment - 2, 5 & 10 Times Tables"
        }
        else if (assignment.assessment_type == "mtcnetlimited2" || assignment.assessment_type == "mtcnetlimited2|access"){
            myname+= "MTC Type assessment - 2, 3, 4, 5, 8 & 10 Times Tables"
        }
        else if (assignment.assessment_type == "mtcnet" || assignment.assessment_type == "mtcnet|access" ){
            myname+= "MTC assessment"
        }
        else if (assignment.assessment_type == "mtc6" || assignment.assessment_type == "mtc6|access" ){
            myname+= "MTC assessment"
        }
        else if (mtcfixeddtype[0] == "mtcfixed"){
            if (mtcfixeddtype[1] == "disapply"){
                myname = "MTC Disapply Assessment" + mtcfixeddtype[2]; 
            }else{
                myname = "MTC Fixed Assessment Year " + mtcfixeddtype[1] + " " + mtcfixeddtype[2].charAt(0).toUpperCase() + mtcfixeddtype[2].slice(1) + " half term " + mtcfixeddtype[3]; 
            }
        }
        else if (assignment.assessment_type.includes("progress")){
            myname = "Year " + assessment_type[0] + " Ready to progress assessment " + assessment_type[3];
        }
        else if (assignment.assessment_type.includes("outwood")){
            myname = "Year " + assessment_type[0] + " " +  assessment_type[2] + " Outwood Spelling Assessment ";
        }
        else if (assignment.assessment_type.includes("arithmetic")){
            myname = "Year " + assessment_type[0] + " arithmetic test " + assessment_type[3]; 
        }
        else{
            if (assessment_type.includes("ks1fixed")){
                if (assessment_type[1].toLowerCase() == "nb5"){
                    myname += " Number Bonds to 5"
                }
                if (assessment_type[1].toLowerCase() == "nb10"){
                    myname += " Number Bonds to 10"
                }
                if (assessment_type[1].toLowerCase() == "nb20"){
                    myname += " Number Bonds to 20"
                }
                if (assessment_type[1].toLowerCase() == "fa"){
                    myname += " Foundational Assessment"
                }
                
            }else{
                //parse the assessment_type
                myname += "Year " + assessment_type[0] + " ";
                myname += assessment_type[2];
                if (assessment_type[3] == "ar"){
                    myname+= " arithmetic assessment"
                }else if (assessment_type[3] == "re"){
                    myname+= " reasoning assessment"
                } else if (assessment_type[3] == "spelling" || assessment_type[3] == "grammar"){
                    myname+= " " + assessment_type[3] + " assessment";
                }else{
                    myname+= " block assessment";
                }
            }
        }

        
    }else{
        if (assignment.assessment_type != null && assignment.assessment_type.includes("learn")){
            myname+= subject.description + " Learn Task"
        }else{
            myname+= subject.description + " Task";
        } 
        
    }

    if (assignment.homework_name != "" && assignment.homework_name != null){
        myname = assignment.homework_name;
    }

    return myname;
}

function Assignment({ assignment, margin, playAssignment, enterPin }) {


    function Play(){
        console.log(assignment);
        console.log(playAssignment);
        if (assignment.pin == "" || assignment.pin == null){
            playAssignment(assignment);
        }else{
            enterPin();
        }
    }

   

    let attempts = 0;
    attempts = assignment.submissions.length;

    let score = 0;
    score = assignment.highest_level_reached;

    let startDate = new Date(assignment.starts_at);
    let date = new Date(assignment.ends_at);

    function formattedDate() {
        return `${date.getDate()}/${("0" + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`;
    }

    function formattedStartDate() {
        return `${startDate.getDate()}/${("0" + (startDate.getMonth() + 1)).slice(-2)}/${startDate.getFullYear()}`;
    }

    let todaysDate = new Date();

    function getCurrentDate(){

        return `${todaysDate.getDate()}/${("0" + (todaysDate.getMonth() + 1)).slice(-2)}/${todaysDate.getFullYear()}`;
        }

    let subject = game_data.find(gd => gd.id == assignment.galaxy_id);

    console.log(assignment);

    //Liam - if there is an important task but it's not past the start time then there's no important until start time
    if(assignment.important >= 1 && startDate.getTime() > todaysDate.getTime()){
       assignment.important = false;
	}
    else{
     //assignment.important = true;
	}
    //end

    // Evaluation rule: Homework only contains submissions that contain "incomplete" in their platform string
    const hasOnlyIncompleteSubmissions = assignment.submissions && 
        assignment.submissions.length > 0 && 
        assignment.submissions.every(sub => sub.platform && typeof sub.platform === 'string' && sub.platform.toLowerCase().includes("incomplete"));

    // Dynamic style setup for header bands
    const headerStyle = {
        position: "relative",
        backgroundColor: hasOnlyIncompleteSubmissions ? "#ffdcb4" : undefined,
        backgroundImage: hasOnlyIncompleteSubmissions ? "none" : undefined,
        color: hasOnlyIncompleteSubmissions ? "#70481c" : undefined
    };

    // Helper function to render Topics button and its popup window
    const renderTopicsButton = () => {
        // Enforce restriction: Do not show Topics button for galaxy id 35
        if (assignment.galaxy_id == 35) {
            return null;
        }

        return (
            <Popup 
                trigger={<TopicsButton type="button">Topics</TopicsButton>} 
                modal 
                nested
                contentStyle={{
                    background: "transparent",
                    border: "none",
                    boxShadow: "none",
                    width: "auto",
                    padding: "0"
                }}
            >
                {close => (
                    <ModalContainer>
                        <h2>Topics</h2>
                        <TopicList>
                            {assignment.topics && assignment.topics.length > 0 ? (
                                assignment.topics.map((topic, index) => (
                                    <li key={index}>{topic.name}</li>
                                ))
                            ) : (
                                <li>No specific topics listed.</li>
                            )}
                        </TopicList>
                        <CloseButton onClick={close}>Close</CloseButton>
                    </ModalContainer>
                )}
            </Popup>
        );
    };

   if(startDate.getTime() > todaysDate.getTime()) //make the assignment grey
   {
    return (
        <AssignmentUpcomingContainer className={margin} >
            <h3 style={headerStyle}>
                {AssignmentName(assignment)}
                {renderTopicsButton()}
            </h3>
            <InfoPane>
                    <StatContainer display="">
                        <IconContainer>
                            
                        </IconContainer>
                        
                    </StatContainer>

                    <StatContainer display="">
                        <IconContainer>
                            
                        </IconContainer>
                       
                    </StatContainer>
                {
                    
                    <DisabledButton disabled={true}>Starts on {formattedStartDate()}</DisabledButton>
                }
            </InfoPane>
        </AssignmentUpcomingContainer>
    );
   }
   else if(assignment.galaxy_id == 35 && attempts > 0)
   {
   return (
        <AssignmentUpcomingContainer className={margin} >
            <h3 style={headerStyle}>
                {AssignmentName(assignment)}
                {renderTopicsButton()}
            </h3>
            <InfoPane>
                    <StatContainer dark={"#c25e09"} >
                        <span>Highest Correct: {score}</span>
                    </StatContainer>

                    {/* Attempts */}
                    <StatContainer dark={"#c25e09"}>
                        <span> {hasOnlyIncompleteSubmissions ? "Attempts: started" : `Attempts: ${attempts}`}</span>
                    </StatContainer>

                   {/* Start Date: */}
                   <StatContainer dark={"#6a4f82"}>
                        <span>Start: {formattedStartDate()}</span>
                    </StatContainer>

                    <StatContainer dark={"#6a4f82"}>
                        <span>Due: {formattedDate()}</span>
                    </StatContainer>          
                {
                    
                    <DisabledButton disabled={true}>Already Completed</DisabledButton>
                }
            </InfoPane>
        </AssignmentUpcomingContainer>
    );
   }

    else if (assignment.submissions.length > 0 || parseInt(assignment.highest_level_reached) > 0) {
        return (
            <AssignmentCompleteContainer className={margin}>
                <h3 style={headerStyle}>
                    {AssignmentName(assignment)}
                    {renderTopicsButton()}
                </h3>
                <InfoPane>
                    <StatContainer dark={"#c25e09"}>
                        <span>Highest Correct: {score}</span>
                    </StatContainer>

                    {/* Attempts */}
                    <StatContainer dark={"#c25e09"}>
                        <span> {hasOnlyIncompleteSubmissions ? "Attempts: started" : `Attempts: ${attempts}`}</span>
                    </StatContainer>

                   {/* Start Date: */}
                   <StatContainer dark={"#6a4f82"}>
                        <span>Start: {formattedStartDate()}</span>
                    </StatContainer>

                    <StatContainer dark={"#6a4f82"}>
                        <span>Due: {formattedDate()}</span>
                    </StatContainer>          
                    {
                        subject.playable ?
                            <PlayButton onClick={() => { Play() }}>Play</PlayButton> :
                            <DisabledButton disabled={true}>Download to Play</DisabledButton>
                    }
                </InfoPane>
            </AssignmentCompleteContainer>
        );
    }

    else if (assignment.important == 0) {
        return (
            <AssignmentContainer className={margin}>
                <h3 style={headerStyle}>
                    {AssignmentName(assignment)}
                    {renderTopicsButton()}
                </h3>
                <InfoPane>
                    <StatContainer dark={"#c25e09"}>
                    <span>Highest Correct: {score}</span>
                    </StatContainer>

                    {/* Attempts */}
                    <StatContainer dark={"#c25e09"}>
                        <span> {hasOnlyIncompleteSubmissions ? "Attempts: started" : `Attempts: ${attempts}`}</span>
                    </StatContainer>

                   {/* Start Date: */}
                   <StatContainer dark={"#6a4f82"}>
                        <span>Start: {formattedStartDate()}</span>
                    </StatContainer>

                    {/* Due Date: */}
                    <StatContainer dark={"#6a4f82"}>
                        <span>Due: {formattedDate()}</span>
                    </StatContainer>

                    
                    {
                        subject.playable ?
                            <PlayButton onClick={() => { Play() }}>Play</PlayButton> :
                            <DisabledButton disabled={true}>Download to Play</DisabledButton>
                    }
                </InfoPane>
            </AssignmentContainer>
        );
    }
    else {
        return (
            <ImportantAssignmentContainer className={margin}>
                <h3 style={headerStyle}>
                    {AssignmentName(assignment)}
                    {renderTopicsButton()}
                </h3>
                <InfoPane>
                    <StatContainer dark={"#c25e09"}>
                    <span>Highest Correct: {score}</span>
                    </StatContainer>

                    {/* Attempts */}
                    <StatContainer dark={"#c25e09"}>            
                        <span> {hasOnlyIncompleteSubmissions ? "Attempts: started" : `Attempts: ${attempts}`}</span>
                    </StatContainer>

                   {/* Start Date: */}
                   <StatContainer dark={"#6a4f82"}>
                        <span>Start: {formattedStartDate()}</span>
                    </StatContainer>

                    <StatContainer dark={"#6a4f82"}>
                        <span>Due: {formattedDate()}</span>
                    </StatContainer>
                    {
                        subject.playable ?
                            <PlayButton onClick={() => { Play() }}>Play</PlayButton> :
                            <DisabledButton disabled={true}>Download to Play</DisabledButton>
                    }
                </InfoPane>
            </ImportantAssignmentContainer>
        );
    }
}

export default Assignment;

const DisabledButton = styled(PlayButton)`
    background: rgb(128, 128, 128);
    user-select: none;
    background: linear-gradient(
        0deg,
        rgba(128, 128, 128, 1) 0%,
        rgba(143, 143, 143, 1) 100%
    );
    border: 2px solid #7d7d7d;
`;

const TopicsButton = styled(PlayButton)`
    position: absolute;
    right: 20px;
    transform: translateY(-50%);
    
    /* Disconnect inherited properties from h3 formatting */
    font-size: 16px !important;
    font-weight: bold !important;
    text-transform: none !important;
    line-height: normal !important;
    letter-spacing: normal !important;
    
    /* Clean custom yellow theme variables */
    background: rgb(234, 146, 19);
    background: linear-gradient(
        0deg,
        rgba(234, 146, 19, 1) 0%,
        rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    color: #fff;
    padding: 0.4em 1.4em;
    border-radius: 0.25em;
    cursor: pointer;
    box-sizing: border-box;

    &:hover {
        background: linear-gradient(
            0deg,
            rgba(255, 186, 32, 1) 0%,
            rgba(234, 146, 19, 1) 100%
        );
    }
`;

const ModalContainer = styled.div`
    padding: 80px;                    
    background: white;
    border-radius: 32px;              
    text-align: center;
    color: #333;
    width: 1000px;                    
    max-width: 95vw;
    box-shadow: 0px 20px 60px rgba(0,0,0,0.3);
    font-family: sans-serif;
    box-sizing: border-box;
    
    h2 {
        margin-top: 0;
        font-size: 4.8em;             
        color: rgb(234, 146, 19);
    }
`;

const TopicList = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 50px 0;                   
    text-align: left;
    
    li {
        padding: 28px 20px;           
        border-bottom: 4px solid #f5f5f5;
        font-size: 3.0em;             
        color: #444;
        line-height: 1.4;
    }
    li:last-child {
        border-bottom: none;
    }
`;

const CloseButton = styled.button`
    margin-top: 30px;                 /* Doubled from 15px */
    padding: 24px 80px;               /* Doubled from 12px 40px */
    background: #e74c3c;
    color: white;
    font-weight: bold;
    border: none;
    border-radius: 16px;              /* Doubled from 8px */
    cursor: pointer;
    transition: background 0.2s ease;
    font-size: 2.6em;                 /* Doubled from 1.3em */
    
    &:hover {
        background: #c0392b;
    }
`;